import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/telecommunications/Template'
import { caseStudyItems } from 'components/cases/Case/CaseStudyItem'

const categoryTitle = '金融/不動産'

const Finance: React.FC<{ pageId: number }> = ({ pageId }) => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])

  return (
    <>
      <CustomHead
        keyword={'事例 実績 金融 保険 信託 証券 生命保険 損害保険 共済'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={`https://aitria.co.jp/cases/finance/page/${pageId}/`}
        title={`${categoryTitle} | 事例 | ページ ${pageId} | Aitria（アイトリア）`}
        description="金融/不動産のケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={pageId} />
    </>
  )
}

export async function getStaticPaths() {
  const filteredItems = caseStudyItems.filter((item) => item.tags.some((tag) => tag.tag === categoryTitle))
  const totalItems = filteredItems.length
  const pageSize = 10
  const totalPages = Math.ceil(totalItems / pageSize)
  const paths = Array.from({ length: totalPages }, (_, i) => ({
    params: { id: (i + 1).toString() },
  }))

  return {
    paths,
    fallback: false,
  }
}

export async function getStaticProps({ params }) {
  return {
    props: {
      pageId: Number(params.id),
    },
  }
}

export default Finance
